// src/components/Common/StaffMessageModal.js (With Admin Contact Info)

import React from 'react';

function StaffMessageModal({ isOpen, onClose, title, message }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg transform transition-all">
                <div className="text-center">
                    <span className="text-5xl">📢</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 my-4 text-center">{title}</h3>
                <p className="text-gray-600 mb-6 whitespace-pre-wrap text-center">{message}</p>
                
                {/* --- NEW SECTION ADDED HERE --- */}
                <div className="mt-6 pt-4 border-t border-gray-200">
                    <p className="text-sm text-center text-gray-500 italic">
                        📞 Masla ho to Admin se baat karein. 
                        <a 
                            href="https://wa.me/923145505585" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-green-600 font-semibold hover:underline ml-1"
                        >
                            WhatsApp (0314-5505585)
                        </a>
                    </p>
                </div>

                <div className="flex justify-center mt-6">
                    <button 
                        onClick={onClose} 
                        className="px-8 py-3 bg-rose-600 text-white rounded-lg hover:bg-rose-700 font-bold focus:outline-none focus:ring-2 focus:ring-rose-500"
                    >
                        Okay, I Understand
                    </button>
                </div>
            </div>
        </div>
    );
}

export default StaffMessageModal;